<div modalHeader class="modal-header py-2">
  <h2 class="mb-0">{{ title }} Service</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>

<form modalContent [formGroup]="serviceForm" class="tr-form-services p-3" novalidate>
  <div class="modal-body">

    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label for="service-name" class="lead col-form-label">Name *</label>
        <p>The display name for this service.</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div class="d-flex">
          <input type="text"
                 class="form-control"
                 id="service-name"
                 formControlName="name"
                 name="serviceName"
                 placeholder="Enter name"
                 [class.is-invalid]="serviceForm.get('name')?.invalid && serviceForm.get('name')?.touched" />
          <label for="service-name" class="col-form-label ml-2 danger">
            <em>{{ serviceForm.get('enabled').value ? "" : "Disabled" }}</em>
          </label>
        </div>
        <control-messages [control]="serviceForm.get('name')"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label for="service-description" class="lead col-form-label">Description <span *ngIf="stripeEnabled">*</span></label>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <textarea
          rows="2"
          class="form-control minh-50"
          id="service-description"
          formControlName="description"
          name="serviceDescription"
          [class.is-invalid]="serviceForm.get('description').invalid && serviceForm.get('description').touched"
        ></textarea>
        <control-messages [control]="serviceForm.get('description')"></control-messages>
      </div>
    </div>

    <div class="row form-group" >
      <div class="col-xs-12 col-sm-5">
        <label for="service-price-min" class="lead col-form-label">Price</label>
        <p>Enter any pricing information you would like displayed.</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div>
          <input
            type="number"
            step="0.01"
            id="service-price-min"
            class="form-control"
            formControlName="price"
            name="servicePriceMin"
            placeholder="0.0"
            [class.is-invalid]="priceControl.invalid && priceControl.touched"
          />
        </div>
        <control-messages [control]="priceControl"></control-messages>
      </div>
    </div>

    <div class="row form-group"  [class.disabled]="isUserOnFreePlan" [ngbTooltip]="isUserOnFreePlan ? 'Not Available on Free Plan' : null">
      <div class="col-xs-12 col-sm-5">
        <label for="service-url-min" class="lead col-form-label">URL</label>
        <p>Enter this if you'd like to make this service available as a direct link</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div>
          <input
            [readonly]="isUserOnFreePlan"
            class="form-control"
            id="service-url-min"
            formControlName="url"
            name="url"
            [class.is-invalid]="serviceForm.get('url').invalid && serviceForm.get('url').touched"
          />
        </div>
        <control-messages [control]="serviceForm.get('url')"></control-messages>
        <div *ngIf="serviceForm.get('url').value && bookingOptions.onlineReservationsEnabled" style="overflow-wrap: anywhere">
          <a class="info-link" href="{{origin}}/p/book/add/{{publicUrl}}/{{serviceForm.get('url').value}}" target="_blank">{{origin}}/p/book/add/{{publicUrl}}/{{serviceForm.get('url').value}}</a>
        </div>
      </div>
    </div>

    <div class="row form-group" formGroupName="availability">
      <div class="col-xs-12 col-sm-5">
        <label for="service-availability-waitlist" class="col-form-label lead">Availability</label>
        <p>Make this service available for walk-ins and/or bookings.</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="service-availability-waitlist"
                   name="availableWaitlist"
                   formControlName="waitlist">
            Public Check-In
          </label>
        </div>
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   id="service-availability-reservations"
                   name="availableReservations"
                   formControlName="reservations">
            Reservations/Appointments
          </label>
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label class="col-form-label lead">Schedule *</label>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <frontend-dropdown
          class="w-100"
          elementId="schedule"
          [items]="availableSchedules"
          bindLabel="name"
          bindValue="_id"
          formControlName="schedule"
          placeholder="Select schedule"
          [clearable]="true"
        ></frontend-dropdown>
      </div>
    </div>

    <div class="row form-group" formGroupName="duration">
      <div class="col-xs-12 col-sm-5">
        <label for="service-duration-hours" class="lead col-form-label">Duration *</label>
        <p>(hours : minutes)</p>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <div class="d-flex">
          <label for="service-duration-hours" class="lead col-form-label"></label>
          <input type="number" min="0"
                 max="23"
                 class="form-control"
                 id="service-duration-hours"
                 formControlName="hours"
                 name="serviceDurationHours"
                 [class.is-invalid]="(serviceForm.get('duration.hours').invalid || serviceForm.get('duration.miliseconds').invalid) && serviceForm.get('duration.hours').touched" />
          <label for="service-duration-minutes" class="lead col-form-label mx-2">:</label>
          <input type="number"
                 min="0"
                 max="59"
                 class="form-control"
                 id="service-duration-minutes"
                 formControlName="minutes"
                 name="serviceDurationMinutes"
                 [class.is-invalid]="(serviceForm.get('duration.minutes').invalid || serviceForm.get('duration.miliseconds').invalid) && serviceForm.get('duration.minutes').touched" />
        </div>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-xs-12 col-sm-5">
        <label class="col-form-label lead">Category</label>
      </div>
      <div class="col-xs-12 col-sm-7 mt-2">
        <frontend-dropdown-plain
          class="w-100"
          elementId="category"
          [items]="categories"
          [addTag]="true"
          [clearable]="true"
          formControlName="category"
          placeholder="Select category"
        ></frontend-dropdown-plain>
      </div>
    </div>
  </div>
</form>

<div modalFooter class="modal-footer">
  <button class="btn btn-info"
          type="submit"
          angularticsCategory="settings"
          angulartics2On="click"
          angularticsAction="Confirm Add/Edit Service"
          [disabled]="serviceForm.pristine || !serviceForm.valid"
          (click)="confirm(serviceForm.value)"
  >Confirm
  </button>
  <button type="button"
          class="btn btn-danger"
          (click)="cancel()"
          angularticsCategory="waitlist"
          angulartics2On="click"
          angularticsAction="Cancel Add/Edit Services">Cancel
  </button>
</div>
